import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'

Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

const routes = [
    {
        path: '/',
        redirect: '/home',
    },
    {
        path: "/home",
        name: 'home',
        component: Layout,
        children: [{
            path: "/home",
            component: () => import('@/views/home'),
            meta: {
                keepAlive: false,
                auth: false,
            },
        }]
    },
    {
        path: "/postgraduate",
        name: 'postgraduate',
        component: Layout,
        children: [{
            path: "/postgraduate",
            component: () => import('@/views/postgraduate/index.vue'),
            meta: {
                title: '研招',
                auth: true,
                keepAlive: false
            },
        }]
    },
    {
        path: "/pgdetail",
        name: 'pgdetail',
        component: Layout,
        children: [{
            path: "/pgdetail",
            component: () => import('@/views/postgraduate/details.vue'),
            meta: {
                title: '招生信息详情',
                auth: true,
                keepAlive: false
            },
        }]
    },
    //     {
    //     path: "/mastermaca",
    //     name: 'mastermaca',
    //     component: Layout,
    //     children: [{
    //         path: "/mastermaca",
    //         component: () => import('@/views/postgraduate/MasterMajorCatalog.vue'),
    //         meta: {
    //             title: '硕士目录',
    //             auth: true,
    //             keepAlive: false
    //         },
    //     }]
    // },
    {
        path: "/pgsdetail",
        name: 'pgsdetail',
        component: Layout,
        children: [{
            path: "/pgsdetail",
            component: () => import('@/views/postgraduate/SchoolDetailLite.vue'),
            meta: {
                title: '学校详情',
                auth: true,
                keepAlive: false
            },
        }]
    },
    {
        path: "/person",
        name: 'person',
        component: Layout,
        children: [{
            path: "/person",
            component: () => import('@/views/home/person'),
            meta: {
                title: '个人中心',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/search",
        name: 'search',
        component: Layout,
        children: [{
            path: "/search",
            component: () => import('@/views/home/search'),
            meta: {
                keepAlive: false
            }
        }]
    },
    {
        path: "/detail",
        name: 'detail',
        component: Layout,
        children: [{
            path: "/detail",
            component: () => import('@/views/home/detail'),
            meta: {
                keepAlive: false
            }
        }]
    },
    {
        path: "/plan_detail",
        name: 'plan_detail',
        component: () => import('@/views/home/plan_detail'),
    },
    {
        path: "/zhiyuan",
        name: 'zhiyuan',
        component: Layout,
        children: [{
            path: "/zhiyuan",
            component: () => import('@/views/zhiyuan'),
            meta: {
                auth: true,
                title: '志愿填报',
                keepAlive: false
            }
        }]
    },
    {
        path: "/zhiyuan_copy",
        name: 'zhiyuan',
        component: Layout,
        children: [{
            path: "/zhiyuan_copy",
            component: () => import('@/views/zhiyuan/zhiyuan_copy'),
            meta: {
                auth: true,
                title: '志愿填报',
                keepAlive: false
            }
        }]
    },
    {
        path: "/school",
        component: Layout,
        children: [{
            path: "/school",
            name: 'school',
            component: () => import('@/views/school'),
            meta: {
                title: '查学校',
                keepAlive: true
            },
        }]
    },
    {
        path: "/schoolDetail",
        component: Layout,
        children: [{
            path: "/schoolDetail",
            name: 'school-detail',
            component: () => import('@/views/school/detail'),
            meta: {
                title: '',
                keepAlive: false
            }
        }]
    },
    {
        path: "/schoolNewsDetail",
        component: Layout,
        children: [{
            path: "/schoolNewsDetail",
            name: 'school-news-detail',
            component: () => import('@/views/school/news'),
            meta: {
                title: '招生快讯详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/singleNewsDetail",
        component: Layout,
        children: [{
            path: "/singleNewsDetail",
            name: 'single-news-detail',
            component: () => import('@/views/school/single_news'),
            meta: {
                title: '单招招生快讯详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/specialNewsDetail",
        component: Layout,
        children: [{
            path: "/singleNewsDetail",
            name: 'special-news-detail',
            component: () => import('@/views/school/special_news'),
            meta: {
                title: '专升本招生快讯详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/singleDetail",
        component: Layout,
        children: [{
            path: "/singleDetail",
            name: 'single-detail',
            component: () => import('@/views/school/single_detail'),
            meta: {
                title: '单招专业详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/major",
        component: Layout,
        children: [{
            path: "/major",
            name: 'major',
            component: () => import('@/views/major'),
            meta: {
                title: '查专业',
                keepAlive: true
            }
        }]
    },
    {
        path: "/tools",
        component: Layout,
        children: [{
            path: "/tools",
            name: 'tools',
            component: () => import('@/views/tools'),
            meta: {
                title: '工具箱',
                keepAlive: false
            }
        }]
    },
    {
        path: "/toolsAdmission",
        component: Layout,
        children: [{
            path: "/toolsAdmission",
            name: 'tools-admission',
            component: () => import('@/views/tools/tools_admission'),
            meta: {
                title: '录取院校测试',
                auth: true,
                keepAlive: true
            }
        }]
    },
    {
        path: "/toolsRank",
        component: Layout,
        children: [{
            path: "/toolsRank",
            name: 'tools-rank',
            component: () => import('@/views/tools/tools_rank'),
            meta: {
                title: '批次位次查询',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/toolsAdvance",
        component: Layout,
        children: [{
            path: "/toolsAdvance",
            name: 'tools-advance',
            component: () => import('@/views/tools/tools_advance'),
            meta: {
                title: '提前批查询',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/imitateAspiration",
        component: Layout,
        children: [{
            path: "/imitateAspiration",
            name: 'imitate-aspiration',
            component: () => import('@/views/zhiyuan/imitate_aspiration'),
            meta: {
                title: '模拟填报',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/smartAspiration",
        component: Layout,
        children: [{
            path: "/smartAspiration",
            name: 'smart-aspiration',
            component: () => import('@/views/zhiyuan/smart_aspiration'),
            meta: {
                title: '一键填报',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/majorDetail",
        component: Layout,
        children: [{
            path: "/majorDetail",
            name: 'major-detail',
            component: () => import('@/views/major/detail'),
            meta: {
                title: '专业详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/rank",
        component: Layout,
        children: [{
            path: "/rank",
            name: 'rank',
            component: () => import('@/views/rank'),
            meta: {
                title: '排行榜',
                keepAlive: true
            }
        }]
    },
    {
        path: "/character",
        component: Layout,
        children: [{
            path: "/character",
            name: 'character',
            component: () => import('@/views/evaluation/character'),
            meta: {
                title: '兴趣测试',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/interest",
        component: Layout,
        children: [{
            path: "/interest",
            name: 'interest',
            component: () => import('@/views/evaluation/interest'),
            meta: {
                title: '性格测试',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/goal",
        component: Layout,
        children: [{
            path: "/goal",
            name: 'goal',
            component: () => import('@/views/evaluation/goal'),
            meta: {
                title: '学业目标测评',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/news",
        component: Layout,
        children: [{
            path: "/news",
            name: 'news',
            component: () => import('@/views/news'),
            meta: {
                title: '高考资讯',
                keepAlive: false
            }
        }]
    },
    {
        path: "/newsDetail",
        component: Layout,
        children: [{
            path: "/newsDetail",
            name: 'news-detail',
            component: () => import('@/views/news/detail'),
            meta: {
                title: '高考资讯详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/video",
        component: Layout,
        children: [{
            path: "/video",
            name: 'video',
            component: () => import('@/views/video'),
            meta: {
                title: '高考课堂',
                keepAlive: false
            }
        }]
    },
    {
        path: "/videoDetail",
        component: Layout,
        children: [{
            path: "/videoDetail",
            name: 'video-detail',
            component: () => import('@/views/video/detail'),
            meta: {
                title: '高考课堂详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/vip",
        component: Layout,
        children: [{
            path: "/vip",
            name: 'vip',
            component: () => import('@/views/vip'),
            meta: {
                title: '开通VIP',
                keepAlive: false
            }
        }]
    },
    {
        path: "/buy",
        component: Layout,
        children: [{
            path: "/buy",
            name: 'buy',
            component: () => import('@/views/vip/buy'),
            meta: {
                title: 'VIP购买',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/orderDetail",
        component: Layout,
        children: [{
            path: "/orderDetail",
            name: 'order-detail',
            component: () => import('@/views/home/order_detail'),
            meta: {
                title: '订单详情',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/payResult",
        component: Layout,
        children: [{
            path: "/payResult",
            name: 'pay-result',
            component: () => import('@/views/vip/pay_result'),
            meta: {
                title: '支付结果',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/download",
        component: Layout,
        children: [{
            path: "/download",
            name: 'download',
            component: () => import('@/views/video/download'),
            meta: {
                title: '资料下载',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/channel",
        component: Layout,
        children: [{
            path: "/channel",
            name: 'channel',
            component: () => import('@/views/channel'),
            meta: {
                title: '特殊招生渠道',
                keepAlive: true
            }
        }]
    },
    {
        path: "/basicPlan",
        component: Layout,
        children: [{
            path: '/basicPlan',
            name: "basic-plan",
            component: () => import('@/views/channel/basic_plan'),
            meta: {
                title: '强基计划',
                keepAlive: true
            }
        }]
    },
    {
        path: "/valuation",
        component: Layout,
        children: [{
            path: '/valuation',
            name: "valuation",
            component: () => import('@/views/channel/valuation'),
            meta: {
                title: '综合评级',
                keepAlive: true
            }
        }]
    },
    {
        path: "/specialPlan",
        component: Layout,
        children: [{
            path: '/specialPlan',
            name: "special-plan",
            component: () => import('@/views/channel/special_plan'),
            meta: {
                title: '专项计划',
                keepAlive: true
            }
        }]
    },
    {
        path: "/overseas",
        component: Layout,
        children: [{
            path: '/overseas',
            name: "overseas",
            component: () => import('@/views/overseas'),
            meta: {
                title: '中澳留学直通车',
                keepAlive: true
            }
        }]
    },
    {
        path: "/sergeant",
        component: Layout,
        children: [{
            path: '/sergeant',
            name: "sergeant",
            component: () => import('@/views/channel/sergeant'),
            meta: {
                title: '定向培养士官',
                keepAlive: true
            }
        }]
    },
    {
        path: "/normalStudents",
        component: Layout,
        children: [{
            path: '/normalStudents',
            name: "normalStudents",
            component: () => import('@/views/channel/normal_students'),
            meta: {
                title: '公费师范生',
                keepAlive: true
            }
        }]
    },
    {
        path: "/highSchool",
        component: Layout,
        children: [{
            path: '/highSchool',
            name: "highSchool",
            component: () => import('@/views/channel/high_school'),
            meta: {
                title: '高职单招',
                keepAlive: true
            }
        }]
    },
    {
        path: "/director",
        component: Layout,
        children: [{
            path: '/director',
            name: "director",
            component: () => import('@/views/art/director'),
            meta: {
                title: '编导',
                keepAlive: true
            }
        }]
    },
    {
        path: "/performance",
        component: Layout,
        children: [{
            path: '/performance',
            name: "performance",
            component: () => import('@/views/art/performance'),
            meta: {
                title: '表演',
                keepAlive: true
            }
        }]
    },
    {
        path: "/broadcast",
        component: Layout,
        children: [{
            path: '/broadcast',
            name: "broadcast",
            component: () => import('@/views/art/broadcast'),
            meta: {
                title: '播音主持',
                keepAlive: true
            }
        }]
    },
    {
        path: "/art",
        component: Layout,
        children: [{
            path: '/art',
            name: "art",
            component: () => import('@/views/art/art'),
            meta: {
                title: '美术',
                keepAlive: true
            }
        }]
    },
    {
        path: "/calligraphy",
        component: Layout,
        children: [{
            path: '/calligraphy',
            name: "calligraphy",
            component: () => import('@/views/art/calligraphy'),
            meta: {
                title: '书法',
                keepAlive: true
            }
        }]
    },
    {
        path: "/dance",
        component: Layout,
        children: [{
            path: '/dance',
            name: "dance",
            component: () => import('@/views/art/dance'),
            meta: {
                title: '舞蹈',
                keepAlive: true
            }
        }]
    },
    {
        path: "/music",
        component: Layout,
        children: [{
            path: '/music',
            name: "music",
            component: () => import('@/views/art/music'),
            meta: {
                title: '音乐',
                keepAlive: true
            }
        }]
    },
    {
        path: "/probability",
        component: Layout,
        children: [{
            path: '/probability',
            name: "probability",
            component: () => import('@/views/tools/probability'),
            meta: {
                title: '测录取概率',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/sameScore",
        component: Layout,
        children: [{
            path: '/sameScore',
            name: "same_score",
            component: () => import('@/views/tools/same_score'),
            meta: {
                title: '同分去向',
                auth: true,
                keepAlive: false
            }
        }]
    },
    {
        path: "/occupation",
        component: Layout,
        children: [{
            path: '/occupation',
            name: "occupation",
            component: () => import('@/views/occupation'),
            meta: {
                title: '查职业',
                auth: true,
                keepAlive: true
            }
        }]
    },
    {
        path: "/occupationDetail",
        component: Layout,
        children: [{
            path: '/occupationDetail',
            name: "occupation_detail",
            component: () => import('@/views/occupation/detail'),
            meta: {
                title: '职业详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/rankEvaluation",
        component: Layout,
        children: [{
            path: '/rankEvaluation',
            name: "rank_evaluation",
            component: () => import('@/views/rank/rank_evaluation'),
            meta: {
                title: '全国学科评估',
                keepAlive: true
            }
        }]
    },
    {
        path: "/gkGuide",
        component: Layout,
        children: [{
            path: '/gkGuide',
            name: "gk_guide",
            component: () => import('@/views/video/gk_guide'),
            meta: {
                title: '高考百科',
                keepAlive: true
            }
        }]
    },
    {
        path: "/guideDetail",
        component: Layout,
        children: [{
            path: "/guideDetail",
            name: 'guide-detail',
            component: () => import('@/views/video/guide_detail'),
            meta: {
                title: '选考科目要求详情',
                keepAlive: false
            }
        }]
    },
    {
        path: "/upgrade",
        component: Layout,
        children: [{
            path: "/upgrade",
            name: 'upgrade',
            component: () => import('@/views/upgrade/index'),
            meta: {
                title: '专升本',
                keepAlive: true
            }
        }]
    },
    {
        path: "/newExamination",
        component: Layout,
        children: [{
            path: "/newExamination",
            name: 'new_examination',
            component: () => import('@/views/new_examination/index'),
            meta: {
                title: '新高考',
                keepAlive: false
            }
        }]
    },
    {
        path: "/querySubject",
        component: Layout,
        children: [{
            path: "/querySubject",
            name: 'query_subject',
            component: () => import('@/views/new_examination/query_subject'),
            meta: {
                title: '选科查询',
                keepAlive: false
            }
        }]
    },
    {
        path: "/submitStudents",
        component: Layout,
        children: [{
            path: "/submitStudents",
            name: 'submit_students',
            component: () => import('@/views/channel/submit_students'),
            meta: {
                title: '保送生',
                keepAlive: true
            }
        }]
    },
    {
        path: '/recommendNews',
        component: Layout,
        children: [
            {
            path: '/recommendNews',
            name: 'recommend_news',
            component: () => import('@/views/channel/recommend_news'),
            meta: { title: '招生动态' }
            }
        ]
    },
    {
        path: '/recommendNewsDetail',
        component: Layout,
        children: [
            {
            path: '/recommendNewsDetail',
            name: 'recommend_news_detail',
            component: () => import('@/views/channel/recommend_news_detail'),
            meta: { title: '招生动态详情' }
            }
        ]
    },
    {
        path: '/recommendPolicyDetail',
        component: Layout,
        children: [
            {
            path: '/recommendPolicyDetail',
            name: 'recommend_policy_detail',
            component: () => import('@/views/channel/recommend_policy_detail'),
            meta: { title: '保送政策详情' }
            }
        ]
    },
    {
        path: "/maintain",
        name: 'maintain',
        component: () => import('@/views/home/maintain'),
        meta: {
            title: '维护',
            keepAlive: true
        }
    },
    {
        path: '*',
        redirect: '/404',
        meta: {
            keepAlive: true
        }
    },
    {
        path: '/404',
        component: () => import('@/views/home/404'),
            meta: {
            keepAlive: true
        }
    },
    // {
    //     path: "/notOpen",
    //     name: 'notOpen',
    //     component: () => import('@/views/home/not_open'),
    //     meta: {
    //         title: '暂未开放',
    //         keepAlive: true
    //     },
    // },
]

const router = new VueRouter({
    mode: 'history',
    routes
})
export default router